export default "__VITE_ASSET__C9I6cenT__"